import React, { Fragment } from 'react'
import { Route, NavLink } from 'react-router-dom'
import AppBar from 'material-ui-legacy/AppBar'
import MenuItem from 'material-ui-legacy/MenuItem'
import Divider from 'material-ui-legacy/Divider'
import Subheader from 'material-ui-legacy/Subheader'
import Container from 'muicss/lib/react/container'
import Row from 'muicss/lib/react/row'
import Col from 'muicss/lib/react/col'

// Icons
import ActionHome from 'material-ui-legacy/svg-icons/action/home'
import ActionSupervisorAccount from 'material-ui-legacy/svg-icons/action/supervisor-account'
import ActionAccountCircle from 'material-ui-legacy/svg-icons/action/account-circle'
import ActionList from 'material-ui-legacy/svg-icons/action/list'
import ActionWork from 'material-ui-legacy/svg-icons/action/work'
import ActionViewModule from 'material-ui-legacy/svg-icons/action/view-module'
import ContentLink from 'material-ui-legacy/svg-icons/content/link'
import ContentArchive from 'material-ui-legacy/svg-icons/content/archive'
import EditorAttachMoney from 'material-ui-legacy/svg-icons/editor/attach-money'
import ActionFace from 'material-ui-legacy/svg-icons/action/face'
import AvMovie from 'material-ui-legacy/svg-icons/av/movie'
import ActionLightbulbOutline from 'material-ui-legacy/svg-icons/action/lightbulb-outline'
import CreateNewFolder from 'material-ui-legacy/svg-icons/file/create-new-folder'
import FolderOpen from 'material-ui-legacy/svg-icons/file/folder-open'
import CommunicationBusiness from 'material-ui-legacy/svg-icons/communication/business'
import SocialPoll from 'material-ui-legacy/svg-icons/social/poll'

// App components
import getVersions from '../stores/version.js'
import auth from '../stores/auth.js'
import AppDrawer from './AppDrawer'
import LogoImg from '../images/grayson-logo.svg'
import LogoutButton from './UI/LogoutButton'
import Projects from './Projects/Projects'
import Agencies from './Agencies/Agencies'
import AgencyProducers from './AgencyProducers/AgencyProducers'
import Directors from "./Directors/Directors";
import Clients from './Clients/Clients'
import Services from './Services/Services'
import ServiceCategories from './ServiceCategories/ServiceCategories'
import ReferenceValues from './ReferenceValues/ReferenceValues'
import Formulas from './Formulas/Formulas'
import Login from './Users/Login'
import Dashboard from './Users/Dashboard'
import Users from './Users/Users'
import MyAccountPage from './Users/MyAccountPage'
import ProjectTypes from './ProjectTypes/ProjectTypes'
import ReportsByProjectType from './Reports/ReportsByProjectType'

// Version subcomponent (private)
const Versions = ({ clientUpdatedAt, serverUpdatedAt }) => {
  const versionStyle = {
    color: 'white',
    fontSize: '12px',
    margin: '15px 15px 0 0'
  }

  return (
    <div style={versionStyle}>
      <strong>API:</strong> {serverUpdatedAt}
      <br />
      <strong>UI:</strong> {clientUpdatedAt}
    </div>
  )
}

// Main app component
class App extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      title: '',
      drawerOpen: false,
      redirect: '',
      clientUpdatedAt: 'N/A',
      serverUpdatedAt: 'N/A'
    }
  }

  componentWillMount() {
    const title = auth.loggedIn()
      ? `Grayson Matthews | Hello ${auth.user().firstName}!`
      : 'Grayson Matthews'
    getVersions()
      .then(result =>
        this.setState({
          title: title,
          clientUpdatedAt: result.clientUpdatedAt,
          serverUpdatedAt: result.serverUpdatedAt
        })
      )
      .catch(error => console.error("Coulnd't get version information:", error))
  }

  _handleToggleDrawer = () =>
    this.setState({ drawerOpen: !this.state.drawerOpen })

  _logout = () => {
    auth.logout()
    this.setState({ title: 'Grayson Matthews' }, this.forceUpdate)
  }

  render() {
    return (
      <section className="app-ui">
        <AppBar
          style={{ position: 'fixed', top: 0, left: 0 }}
          title={this.state.title}
          iconClassNameRight="muidocs-icon-navigation-expand-more"
          onLeftIconButtonClick={this._handleToggleDrawer}
        >
          <Versions
            clientUpdatedAt={this.state.clientUpdatedAt}
            serverUpdatedAt={this.state.serverUpdatedAt}
          />
          {auth.loggedIn() && <LogoutButton onTouchTap={this._logout} />}
          <img
            src={LogoImg}
            alt="Logo"
            style={{ height: '48px', marginTop: '5px' }}
          />
        </AppBar>

        {auth.loggedIn() && (
          <AppDrawer
            open={this.state.drawerOpen}
            closeCallback={this._handleToggleDrawer}
          >
            <NavLink exact to="/">
              <MenuItem
                primaryText="Home"
                leftIcon={<ActionHome />}
                onTouchTap={this._handleToggleDrawer}
              />
            </NavLink>
            <NavLink to="/my-account">
              <MenuItem
                primaryText="My Account"
                leftIcon={<ActionAccountCircle />}
                onTouchTap={this._handleToggleDrawer}
              />
            </NavLink>
            <Divider />

            <Subheader>Projects</Subheader>
            <NavLink to="/projects/new">
              <MenuItem
                leftIcon={<CreateNewFolder />}
                primaryText="New project"
                onTouchTap={this._handleToggleDrawer}
              />
            </NavLink>
            <NavLink exact to="/projects">
              <MenuItem
                leftIcon={<ActionList />}
                primaryText="Active projects"
                onTouchTap={this._handleToggleDrawer}
              />
            </NavLink>
            <NavLink exact to="/projects/inactive">
              <MenuItem
                leftIcon={<ContentArchive />}
                primaryText="Archived/dead projects"
                onTouchTap={this._handleToggleDrawer}
              />
            </NavLink>
            <Divider />

            <Subheader>Listings</Subheader>
            <NavLink to="/clients">
              <MenuItem
                leftIcon={<CommunicationBusiness />}
                primaryText="Clients"
                onTouchTap={this._handleToggleDrawer}
              />
            </NavLink>
            <NavLink to="/agencies">
              <MenuItem
                leftIcon={<ActionLightbulbOutline />}
                primaryText="Agencies"
                onTouchTap={this._handleToggleDrawer}
              />
            </NavLink>
            <NavLink to="/agency-producers">
              <MenuItem
                leftIcon={<ActionFace />}
                primaryText="External PMs"
                onTouchTap={this._handleToggleDrawer}
              />
            </NavLink>
            <NavLink to="/directors">
              <MenuItem
                leftIcon={<AvMovie />}
                primaryText="Directors"
                onTouchTap={this._handleToggleDrawer}
              />
            </NavLink>
            <Divider />

            <Subheader>Reports</Subheader>
            <NavLink to="/reports/project-type">
              <MenuItem
                leftIcon={<SocialPoll />}
                primaryText="By project type"
                onTouchTap={this._handleToggleDrawer}
              />
            </NavLink>
            <Divider />

            {auth.isAdmin() && (
              <section>
                <Subheader>Service management</Subheader>
                <NavLink to="/project-types">
                  <MenuItem
                    leftIcon={<FolderOpen />}
                    primaryText="Project types"
                    onTouchTap={this._handleToggleDrawer}
                  />
                </NavLink>
                <NavLink to="/services">
                  <MenuItem
                    leftIcon={<ActionWork />}
                    primaryText="Services"
                    onTouchTap={this._handleToggleDrawer}
                  />
                </NavLink>
                <NavLink to="/service-categories">
                  <MenuItem
                    leftIcon={<ActionViewModule />}
                    primaryText="Service categories"
                    onTouchTap={this._handleToggleDrawer}
                  />
                </NavLink>
                <NavLink to="/reference-values">
                  <MenuItem
                    leftIcon={<ContentLink />}
                    primaryText="Reference values"
                    onTouchTap={this._handleToggleDrawer}
                  />
                </NavLink>
                <NavLink to="/formulas">
                  <MenuItem
                    leftIcon={<EditorAttachMoney />}
                    primaryText="Formulas"
                    onTouchTap={this._handleToggleDrawer}
                  />
                </NavLink>
                <Divider />

                <Subheader>User management</Subheader>
                <NavLink to="/users">
                  <MenuItem
                    leftIcon={<ActionSupervisorAccount />}
                    primaryText="Users"
                    onTouchTap={this._handleToggleDrawer}
                  />
                </NavLink>
                <Divider />
              </section>
            )}
          </AppDrawer>
        )}

        <Container fluid>
          <Row>
            <Col xs="12" className="master-container">
              {!auth.loggedIn() && <Route path="/" component={Login} />}
              {auth.loggedIn() && (
                <Fragment>
                  <Route path="/" exact component={Dashboard} />
                  <Route path="/login" component={Login} />
                  <Route path="/projects" component={Projects} />
                  <Route path="/agencies" component={Agencies} />
                  <Route path="/agency-producers" component={AgencyProducers} />
                  <Route path="/directors" component={Directors} />
                  <Route path="/clients" component={Clients} />
                  <Route path="/my-account" component={MyAccountPage} />
                  <Route
                    path="/reports/project-type"
                    exact
                    component={ReportsByProjectType}
                  />
                </Fragment>
              )}
              {auth.isAdmin() && (
                <Fragment>
                  <Route path="/services" component={Services} />
                  <Route
                    path="/service-categories"
                    component={ServiceCategories}
                  />
                  <Route path="/reference-values" component={ReferenceValues} />
                  <Route path="/formulas" component={Formulas} />
                  <Route path="/users" component={Users} />
                  <Route path="/project-types" component={ProjectTypes} />
                </Fragment>
              )}
            </Col>
          </Row>
        </Container>
      </section>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/components/App.jsx